module.exports = __WEBPACK_EXTERNAL_MODULE_50__;


//////////////////
// WEBPACK FOOTER
// external "core-js/modules/es7.symbol.async-iterator"
// module id = 50
// module chunks = 0